import { createContext } from '@lit/context';
import { SOURCE } from '../util/source';

export const sourceContext = createContext<SOURCE>(Symbol('source'));
